import React, { FC, useState } from 'react';
import { Tooltip } from 'antd';
import { NavLink } from 'react-router-dom';
import { CountBadge } from 'common/components';
import { getSidebarItemClassName } from 'common/helpers';
import { ISidebarItem } from 'common/models';

interface IComponentProps {
  item: ISidebarItem;
  sidebarOpened: boolean;
  bodyHovered: boolean;
  hoveredKey: string;
  onHoveredKeyChange: (value: string) => void;
}

export const SidebarItem: FC<IComponentProps> = ({ item, sidebarOpened, bodyHovered, hoveredKey, onHoveredKeyChange }) => {
  const [hovered, setHovered] = useState<boolean>(false);

  const { key, show, to, icon, label, description, group, end, badge, onClick } = item;

  const toggleHovered = () => {
    if (hovered) {
      onHoveredKeyChange('');
      setHovered(false);
    } else {
      onHoveredKeyChange(key);
      setHovered(true);
    }
  };

  const getTooltipClassName = () => {
    let className = 'sidebar-item__tooltip';

    if (group === 'body') {
      className += ' sidebar-item__tooltip-body';

      if (hoveredKey === key) {
        className += ' hover';
      }
    }

    return className;
  };

  if (!show) {
    return null;
  }

  return (
    <NavLink to={to} className={({ isActive }) => getSidebarItemClassName(isActive, key)} onClick={onClick} end={end}>
      <Tooltip
        overlayClassName={getTooltipClassName()}
        open={sidebarOpened && (hovered || (group === 'body' && bodyHovered && !hovered))}
        title={description}
        placement="right"
      >
        <div
          className={`sidebar-item__icon ${badge ? 'sidebar-item__icon-badge' : ''}`}
          onMouseEnter={toggleHovered}
          onMouseLeave={toggleHovered}
        >
          {icon}
        </div>
      </Tooltip>

      <div className="sidebar-item__label">
        <span className="text-h4">{label}</span>

        <CountBadge count={badge} />
      </div>
    </NavLink>
  );
};
